<p>
  {{'EXTRACOPYDLG.EXTRACOPYDRIVE' | translate }}
</p>
<input type="submit" value="{{'EXTRACOPYDLG.PROCEED' | translate}}" class="cb-btn" (click)="ok()"/>
<input type="submit" value="{{'EXTRACOPYDLG.CANCEL' | translate}}" class="cb-btn" (click)="no()"/>
